import CustomModal from "../../../common/components/modal/CustomDetailModal";
import { Column, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import { useEffect, useState } from "react";
import { C3Text } from "../../../common/components/text/CustomText";
import CustomIcon from "../../../common/components/image/CustomIcon";
import { CustomTable, UserRequestStatusBadge } from "../../../common/components/table/CustomTable";
import RoleRequestUserInfoSubModal from "./RoleRequestUserInfoSubModal";
import { Theme } from "../../../common/Theme";
import { useDevice } from "../../../common/hooks/useDevice";
import LMPAuthApi from "../../../api/lmp/LMPAuthApi";
import LocalStorageKey from "../../../common/enums/LocalStorageKey";
import ParseUtil from "../../../common/utils/ParseUtil";
import MaskUtil from "../../../common/utils/MaskUtil";
import UserManagementButton from "../../../common/components/filter_button/UserManagementButton";

export default function UserRoleRequestsModal({ isOpen, onClose }) {
    const [statusFilter, setStatusFilter] = useState("all");

    // TODO: LMPAuthApi의 역할 승인 API 연동 필요
    // 현재는 mockData를 사용. LMPAuthApi의 역할 승인 요청 목록 조회 및 승인/반려 API가 준비되면 교체할 것.
    const api = new LMPAuthApi();
    const [data, setData] = useState([]);
    const [totalPage, setTotalPage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        getList(currentPage, statusFilter);
    }, [currentPage, statusFilter]);

    const handleStatusFilterChange = (value) => {
        setStatusFilter(value);
        setCurrentPage(1);
    };

    const getList = (page, statusFilter) => {
        const accessToken = localStorage.getItem(LocalStorageKey.accessToken);
        api.getRoleApprovalList({
            accessToken,
            page: page,
            pageSize: 15,
            apprStat: statusFilter === "all" ? undefined : statusFilter,
        })
            .then((resp) => {
                const roleApprList = resp?.role?.roleApprList ?? [];
                Promise.all(
                    roleApprList.map((element) =>
                        api
                            .getUserInfoByAdmin({
                                accessToken,
                                usrNo: element.usrNo,
                            })
                            .then((result) => ({
                                ...element,
                                email: result.account.userID,
                            }))
                            .catch((error) => {
                                console.error(error);
                                return element;
                            })
                    )
                ).then((enrichedList) => {
                    setTotalPage(resp?.role?.totPage ?? 1);
                    setData(enrichedList);
                });
            })
            .catch((error) => {
                // LMP 게이트웨이는 비즈니스 에러를 406으로 내려주며, 실제 원인은 응답 바디 error.code에 담긴다.
                const lmpError = error?.response?.data?.error;
                console.error("getRoleApprovalList 실패 - status:", error?.response?.status, "error:", lmpError ?? error);
                setData([]);
                setTotalPage(1);
            });
    };

    // 테이블
    const tableHeaders = [
        {
            key: "requestTime",
            label: "Request Time",
            render: (row) => {
                const [datePart, timePart] = ParseUtil.formatDateTime(row.reqDate).split(" ");
                return (
                    <Column>
                        <C3Text>{datePart}</C3Text>
                        <C3Text>{timePart}</C3Text>
                    </Column>
                );
            },
        },
        {
            key: "completeTime",
            label: "Complete Time",
            render: (row) => {
                if (!row.aprvDate) {
                    return <C3Text>-</C3Text>;
                }
                const [datePart, timePart] = ParseUtil.formatDateTime(row.aprvDate).split(" ");
                return (
                    <Column>
                        <C3Text>{datePart}</C3Text>
                        <C3Text>{timePart}</C3Text>
                    </Column>
                );
            },
        },
        {
            key: "status",
            label: "Status",
            render: (row) => (
                <UserRequestStatusBadge>{ParseUtil.formatUserStatus(row.apprvFlag)}</UserRequestStatusBadge>
            ),
        },
        {
            key: "usrNo",
            label: "ID",
            render: (row) => (
                <C3Text>
                    {row.email && row.email.includes("@") ? MaskUtil.maskEmail(row.email) : MaskUtil.maskId(row.email)}
                </C3Text>
            ),
        },
        {
            key: "type",
            label: "Type",
            render: (row) => {
                const type = ParseUtil.formatUserType(row.roleId);
                return <C3Text>{type}</C3Text>;
            },
        },
        {
            key: "button",
            label: "View",
            render: (row) => (
                <CustomIcon
                    iconName={"checked_square_box"}
                    size={"18px"}
                    cursor={"pointer"}
                    onClick={() => {
                        setDetailDto({
                            type: ParseUtil.formatUserType(row.roleId),
                            id: row.usrNo,
                            email: row.email,
                            status: "Enable",
                            name: "",
                            contact: "",
                            seqNo: row.seqNo,
                            apprvFlag: row.apprvFlag,
                        });
                        setOpenDetailModal(true);
                    }}
                />
            ),
        },
    ];

    // 유저 상세 모달
    const [openDetailModal, setOpenDetailModal] = useState(false);
    const [detailDto, setDetailDto] = useState({
        type: "Shop Owner",
        id: "Hello",
        status: "Enable",
        name: "123",
        contact: "123",
    });

    const currentDevice = useDevice();

    return (
        <CustomModal
            title={"User Requests"}
            isOpen={isOpen}
            onClose={onClose}
            width={currentDevice === "mobile" || currentDevice === "tablet" ? "90vw" : "870px"}
            side={currentDevice === "mobile" || currentDevice === "tablet" ? "center" : "right"}
            height={"90vh"}
            hasPagination
            isCloseIfOutside={false}
            totalPage={totalPage}
            currentPage={currentPage}
            changePage={(page) => setCurrentPage(page)}
        >
            <Row alignItem={"flex-start"} justifyContent={"space-between"} width={"100%"}>
                <UserManagementButton currentValue={statusFilter} setValue={handleStatusFilterChange} />
                <Row alignItem={"center"} justifyContent={"center"} height={"36px"}>
                    <C3Text
                        fontColor={Theme.color.rose500}
                        fontWeight={"500"}
                        textAlign={"center"}
                        lineHeight={"-200%"}
                    >
                        New 1
                    </C3Text>
                    <SizedBox width={"6px"} />
                    <CustomIcon iconName={"bell_red"} size={"18px"} />
                </Row>
            </Row>
            <SizedBox height={"12px"} width={"100%"} />
            <CustomTable headers={tableHeaders} data={data} />
            {openDetailModal && (
                <RoleRequestUserInfoSubModal
                    isOpen={openDetailModal}
                    onClose={() => setOpenDetailModal(false)}
                    dto={detailDto}
                    currentPage={currentPage}
                    getList={getList}
                ></RoleRequestUserInfoSubModal>
            )}
        </CustomModal>
    );
}
